module.exports = __webpack_public_path__ + "img/retail.00ef7d97.jpg";